<template>
  <v-container fluid grid-list-md>
    <v-layout justify-space-between row wrap>
      <v-flex v-for="(item, i) in informations" :key="i" :class="item.class">
        <v-list three-line light class="py-0 elevation-2">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-bold">{{item.title}}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{item.subtitle}}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{item.value | currency}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <h3>Submódulo 4.1 - Ausencias Legais</h3> 
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Substituto na Corbetura de Férias (em %)"
          v-model="moduleFour.vacation" 
          :hint="vacationValue | currency" 
          persistent-hint
          v-bind="currency_config_percent">
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-currency-field
          box :readonly="budgetFinalized"
          label="Substituto na Corbetura Ausências Legais (em %)"
          v-model="moduleFour.legalAbsences" 
          :hint="legalAbsencesValue | currency" 
          persistent-hint
          v-bind="currency_config_percent">
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Substituto na Corbetura Licença Paternidade (em %)"
          v-model="moduleFour.paternityLicence" 
          :hint="paternityLicenceValue | currency" 
          persistent-hint
          v-bind="currency_config_percent">
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Substituto na Corbetura Ausência por Acidente do Trabalho (em %)" 
          v-model="moduleFour.workAccident" 
          :hint="workAccidentValue | currency" 
          persistent-hint
          v-bind="currency_config_percent">
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Substituto na Corbetura Afastamento Maternidade (em %)"
          v-model="moduleFour.maternityLicence" 
          :hint="maternityLicenceValue | currency" 
          persistent-hint
          v-bind="currency_config_percent">
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Incidência dos encargos do Submódulo 2.2 sobre o Custo de Reposição do Profissional Ausente (em %)"
          v-model="moduleFour.professionalAbsent" 
          :hint="professionalAbsentValue | currency" 
          persistent-hint
          v-bind="currency_config_percent">
        </v-currency-field>
      </v-flex>
      <v-flex xs12>
        <v-layout v-show="moduleFour.others.length > 0" v-for="(item, i) in moduleFour.others" :key="i">
          <v-flex :class="budgetFinalized ? 'xs12' : 'xs11'">
            <v-layout justify-start row wrap>
              <v-flex xs12 sm6>
                <v-text-field label="Descrição" v-model="item.description" box :readonly="budgetFinalized"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-currency-field 
                  box :readonly="budgetFinalized"
                  label="Porcentagem de Cálculo (%)"
                  title="A porcentagem digitada será multiplicada pela base de cálculo (Módulo 1 + Submódulo 2.1)"
                  v-bind="currency_config_percent"
                  :hint="`${item.percent * calculationBasis / 100}` | currency"
                  persistent-hint
                  v-model="item.percent"
                >
                </v-currency-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs1 v-if="!budgetFinalized">
            <v-layout align-center justify-center row fill-height>
              <v-icon class="red--text font-weight-black" title="Remover benefício" @click.stop.prevent="removeBenefit(item);">delete_forever</v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md6 v-if="!budgetFinalized">
        <v-btn block color="primary" title="Adicionar Outro Benefício" @click.native.stop.prevent="addBenefit();">
          Adicionar Outro Benefício
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-list three-line light class="py-0 elevation-2">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-bold">Total do Submódulo 4.1</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{amountOfModuleFourOnePercent.toFixed(4)}}%</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{amountOfModuleFourOne | currency}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <!-- Submódulo 4.1 -->
    <!-- Submódulo 4.2 -->
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <h3>Submódulo 4.2 – Intrajornada</h3> 
      </v-flex>
      <v-flex xs12 sm6>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Substituto na Corbetura Intervalo para Repouso e Alimentação (em %)" 
          v-model="moduleFour.restAndFeeding" 
          :hint="restAndFeedingValue | currency" 
          persistent-hint
          v-bind="currency_config_percent">
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-list two-line light class="py-0 elevation-2">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-bold">Total do Submódulo 4.2</v-list-tile-title>
              <v-list-tile-sub-title>{{amountOfModuleFourTwo | currency}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <!-- Submódulo 4.2 -->
    <!-- NOTAS -->
    <v-layout row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
      </v-flex>
      <v-flex xs12>
        <v-textarea v-model="moduleFour.notes" label="Notas" rows="5" box :readonly="budgetFinalized"></v-textarea>
      </v-flex>
    </v-layout>
    <!-- NOTAS -->
  </v-container>
</template>

<script>
  import ModuleFourService from '../../service/ModuleFourService';
  import SheetDefaultData from '../../data/sheet/SheetDefaultData'
  import {mapState} from "vuex";
import Currency from '../../utils/Currency';

  export default {
    name: "TabModule3",

    data() {
      return {
        currency_config_percent: Currency.percent
      };
    },
    methods: {
      addBenefit() {
        if(!this.moduleFour.others)
          this.moduleFour.others = new Array()

        this.moduleFour.others.push({
          description: "",
          percent: 0,
        });
      },
      removeBenefit(item) {
        this.moduleFour.others.splice(this.moduleFour.others.indexOf(item), 1);
      },
      async setSheetModuleFour() {
        let sheet = this.$store.getters.getAnalyticalWorksheet
        if(sheet.moduleFour != this.moduleFour){
          sheet.moduleFour = Object.assign({}, this.moduleFour)
          await this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);
        }
      }, // setSheetModuleFour() //      
    },

    computed: {
      amountOfModuleFour() {
        let amount = this.amountOfModuleFourOne + this.amountOfModuleFourTwo

        this.$store.commit("SET_AMOUNT_OF_MODULE_FOUR", amount);

        return amount
      },
      amountOfModuleFourOne() {
        return ModuleFourService.getAmountOfModuleFourOne(this.calculationBasis, this.moduleFour)
      },
      amountOfModuleFourOnePercent() {
        return ModuleFourService.getAmountOfModuleFourOnePercents(this.moduleFour)
      },
      amountOfModuleFourTwo() {
        return ModuleFourService.getAmountOfModuleFourTwo(this.calculationBasis, this.moduleFour)
      },
      calculationBasis(){
        return this.amountOfModuleOne + this.amountOfModuleTwoOne
      },
      informations(){
        return [
          {
            class: "xs12 sm4",
            title: "Valor da Remuneração",
            subtitle: "Total do Módulo 1",
            value: this.amountOfModuleOne
          },
          {
            class: "xs12 sm4",
            title: "Base de Cálculo",
            subtitle: "Módulo 1 + Submódulo 2.1",
            value: this.calculationBasis
          },
          {
            class: "xs12 sm4",
            title: "Total do Módulo 4",
            subtitle: "Soma dos valores",
            value: this.amountOfModuleFour
          }
        ]
      },
      legalAbsencesValue() {
        return this.calculationBasis * this.moduleFour.legalAbsences / 100
      },
      maternityLicenceValue() {
        return this.calculationBasis * this.moduleFour.maternityLicence / 100
      },
      moduleFour(){
        if(this.analyticalWorksheet.moduleFour)
          return this.analyticalWorksheet.moduleFour
        
        return SheetDefaultData.getModuleFour()
      },
      othersPercent(){
        return ModuleFourService.getOthersPercent(this.moduleFour.others)
      },
      othersValue(){
        return this.calculationBasis * this.othersPercent / 100
      },
      paternityLicenceValue() {
        return this.calculationBasis * this.moduleFour.paternityLicence / 100
      },
      professionalAbsentValue() {
        return this.calculationBasis * this.moduleFour.professionalAbsent / 100
      },
      restAndFeedingValue() {
        return this.calculationBasis * this.moduleFour.restAndFeeding / 100
      },
      vacationValue() {
        return this.calculationBasis * this.moduleFour.vacation / 100
      },      
      workAccidentValue() {
        return this.calculationBasis * this.moduleFour.workAccident / 100
      },
      ...mapState({analyticalWorksheet: state => state.budget.analyticalWorksheet}),
      ...mapState({amountOfModuleOne: state => state.budget.amountOfModuleOne}),
      ...mapState({amountOfModuleTwoOne: state => state.budget.amountOfModuleTwoOne}),
      ...mapState({budgetFinalized: state => state.budget.budgetFinalized})
    },
    watch: {
      moduleFour: {
        handler: function(newValue, oldValue) {
          this.setSheetModuleFour()
        },
        deep: true
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/budget/TabModule4.vue